
const isSame = (date1, date2) => {
  return date1.getDate() == date2.getDate() &&
    date1.getMonth() == date2.getMonth() &&
    date1.getFullYear() == date2.getFullYear();
};

function toLocalTimeZone(dateTime){
  var localDate = new Date(dateTime);
  var monthNames = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
  ];

  var timeString = '';
  var today = new Date();
  var yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if ( isSame(localDate, today) ){
    timeString = 'today ';
  }
  else if(isSame(localDate, yesterday)){
    timeString = 'yesterday ';
  }
  else{
    timeString = monthNames[localDate.getMonth()] + ' ' + localDate.getDate() + ' ' + localDate.getFullYear()+' ';
  }

  timeString += localDate.toLocaleString('en-US', { hour: 'numeric', minute:'numeric', hour12: true });
  return timeString;
}




export { toLocalTimeZone };